import * as angular from 'angular';
import Toast from './toast';
import TimeInput from './time-input/time.input';
import dateRanges from './dateRanges';
import Pagination from './pagination/pagination';
import PaginationService from './pagination/pagination.service';
import TooltipHelp from './tooltip-help/tooltip.help';
import ModalService from './modal/modal.service';
import ngFocusModel from './focusModel';
import ngEnter from './ngEnter';
import parseDate from './parseDate';
import selectClear from './selectClear';
import timeParser from './timeParser';
import uiNav from './ui-nav';
import numbersOnly from './numbersOnly';
import multipleUiSelectRequired from './multipleUiSelectRequired';
import truncate from './truncate';
import orderByTranslated from './orderByTranslated';
import sameDelete from './sameDelete';
import LiveChatService from './live-chat/live.chat.service.js';
import isoCodeCountryToCountry from './isoCodeCountryToCountry.js';
import isoCodeCountryToDialCode from './isoCodeCountryToDialCode';
import WebRtcUtil from './webrtc/webrtc.util.js';
import ContactInfo from './info/contact.info';
import ipUserInfo from './ip-user-info/ip.user.info.service';
import PhoneNumber from './phoneNumber';
import DateFormat from './date.format';
import AutoDisable from './auto.disable';
import paginationInput from './pagination/pagination.input';
import SecToTimeService from './secToTime.service';
import LeadGenerationApi from './leadGenerationApi.service';
import ProfitwellService from './profitwell/profitwell.service';
import Player from './player/player';
import GtmService from './gtm.service';
import TransferData from './modal/transfer.data.service';
import LimitTitle from './modal/limit-title/limit.title';
import * as LodashService from 'lodash';
import ProgressService from './progress/progress.service';
import CloseSelect from './close-select/close.select';
import DisableDragnDrop from './disable.dragndrop';
import { FileDrop } from './file-drop/file-drop';
import { FileDropPlayer } from './file-drop/file-drop-player';
import disableFourByteChars from "./disableFourByteChars";
import LastStateService from "./localstorage/lastState.service";
import RolesService from "./roles.service";
import BootstrapService from "./bootstrap.service";
import MsisdnsService from "./msisdns.service";
import InstanceConfigService from './instance-config.service';
import WidgetService from './widget.service'

export default angular
  .module('CrazyWeb.Utils', [])
  .service('Toast', Toast)
  .service('paginationService', PaginationService)
  .service('ModalService', ModalService)
  .service('dateRanges', dateRanges)
  .service('IntlTelInput', function() {
    return $.fn.intlTelInput;
  })
  .service('IntlTelInputUtils', function() {
    if (!window['intlTelInputUtils']) console.error('intlTelInputUtils is not loaded');
    return window['intlTelInputUtils'];
  })
  .service('WebRtcUtil', WebRtcUtil)
  .service('timeParser', timeParser)
  .service('LiveChat', LiveChatService)
  .service('ipUserInfo', ipUserInfo)
  .service('DateFormat', DateFormat)
  .service('SecToTimeService', SecToTimeService)
  .service('LeadGenerationApi', LeadGenerationApi)
  .service('BootstrapService', BootstrapService)
  .service('RolesService', RolesService)
  .service('MsisdnsService', MsisdnsService)
  .service('WidgetService', WidgetService)
  .service("InstanceConfigService", InstanceConfigService)
  .service('ProfitwellService', ProfitwellService)
  .service('GtmService', GtmService)
  .service('TransferData', TransferData)
  .service('LastStateService', LastStateService)
  .service('LodashService', function() {
    return LodashService;
  })
  .service('ProgressService', ProgressService)
  .filter('isoToCountry', isoCodeCountryToCountry)
  .filter('isoToDialCode', isoCodeCountryToDialCode)
  .filter('parseDate', parseDate)
  .filter('truncate', truncate)
  .filter('sameDelete', sameDelete)
  .filter('phoneNumber', PhoneNumber)
  .filter('orderByTranslated', orderByTranslated)
  .directive('ngFocusModel', ngFocusModel)
  .directive('ngEnter', ngEnter)
  .directive('paginationInput', paginationInput)
  .directive('selectClear', selectClear)
  .directive('disableFourByteChars', disableFourByteChars)
  .directive('uiNav', uiNav)
  .directive('player', Player)
  .directive('numbersOnly', numbersOnly)
  .directive('multipleUiSelectRequired', multipleUiSelectRequired)
  .directive('autoDisable', AutoDisable)
  .directive('disableDragnDrop', DisableDragnDrop)
  .component('timeInput', TimeInput)
  .component('contactInfo', ContactInfo)
  .component('pagination', Pagination)
  .component('tooltipHelp', TooltipHelp)
  .component('limitTitle', LimitTitle)
  .component('closeSelect', CloseSelect)
  .component('fileDrop', FileDrop)
  .component('fileDropPlayer', FileDropPlayer)
  .name;
